import type { Capability } from 'owa-capabilities';
import type { MailboxInfo } from 'owa-client-types';
import { isHosted } from 'owa-config';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';

/**
 * NOTE: Please see the README for more information on how the
 * capability functions must be implemented and used.
 *
 * My Day per-workload persistence restores the pane at boot and on module switches, which is
 * Outlook shell behavior. Surfaces that embed Outlook - Teams and the other MetaOS hubs, and the
 * OPX surfaces - own their own pane chrome and must never have a pane opened on their behalf.
 *
 * `isSupported` keys off the path rather than the hub identity: `/hosted` and `/opx` are served by
 * their own bootstrap entries, so this is already correct before the hub context resolves and
 * getHostHub() becomes readable. A getHostHub() check alone would read undefined that early and
 * let the host through. It resolves synchronously, so it is safe to evaluate from eager
 * orchestrators. Monarch and OWA both run the default shell entry and so are both supported.
 *
 * No mailbox info is used: the feature is scoped to the session's surface and is gated by a global
 * flight, so the capability evaluates identically for every account in the session.
 */
export const myDayPerWorkloadPersistenceCapability: Capability = {
    isEnabled: (_mailboxInfo?: MailboxInfo) => {
        return isGlobalFeatureEnabled('cal-myday-per-workload-persistence');
    },
    isSupported: (_mailboxInfo?: MailboxInfo) => {
        return !isHosted();
    },
};
